import { createSlice } from '@reduxjs/toolkit';

import { ZoneFormDrawerSchema } from '../types';

const initialState: ZoneFormDrawerSchema = {
  mode: null,
  zone: null,
};

export const zoneFormDrawerSlice = createSlice({
  name: 'zoneFormDrawer',
  initialState,
  reducers: {
    setOpenZoneForm: (state, action) => {
      state.mode = action.payload.mode;
      state.zone = action.payload.zone || null;
    },
    closeZoneForm: (state) => {
      state.mode = null;
      state.zone = null;
    },
  },
});

export const zoneFormDrawerActions = zoneFormDrawerSlice.actions;
export const zoneFormDrawerReducer = zoneFormDrawerSlice.reducer;
